import { buttonClassNames, makeResetStyles, makeStyles, mergeClasses } from '@fluentui/react-components';
import type {
  GroundingMenuSubmenuHeaderSlots,
  GroundingMenuSubmenuHeaderState,
} from './GroundingMenuSubmenuHeader.types';
import type { SlotClassNames } from '@fluentui/react-components';
import { tokens, typographyStyles } from '@fluentui-copilot/tokens';

export const groundingMenuSubmenuHeaderClassNames: SlotClassNames<
  Omit<GroundingMenuSubmenuHeaderSlots, 'backButtonTooltip'>
> = {
  root: 'fai-GroundingMenuSubmenuHeader',
  backButton: 'fai-GroundingMenuSubmenuHeader__backButton',
  primaryText: 'fai-GroundingMenuSubmenuHeader__primaryText',
  secondaryText: 'fai-GroundingMenuSubmenuHeader__secondaryText',
};

const useRootClassName = makeResetStyles({
  display: 'grid',
  gridTemplateRows: 'auto auto',
  gridTemplateColumns: 'auto 1fr',
  columnGap: tokens.spacingHorizontalM,
  paddingInlineStart: tokens.spacingHorizontalXS,
  paddingBlock: tokens.spacingVerticalSNudge,
});

const usePrimaryTextClassName = makeResetStyles({
  ...typographyStyles.body1,
});

const useSecondaryTextClassName = makeResetStyles({
  ...typographyStyles.caption2,
  color: tokens.colorNeutralForeground2,
});

const useBackButtonStyles = makeStyles({
  root: {
    gridRow: 'span 2',
    alignSelf: 'center',
    [`& > .${buttonClassNames.icon}:not:hover`]: {
      '@media (forced-colors: none)': {
        color: tokens.colorNeutralForeground3,
      },
    },
  },
});

/**
 * Apply styling to the GroundingMenuSubmenuHeader slots based on the state
 */
export const useGroundingMenuSubmenuHeaderStyles_unstable = (
  state: GroundingMenuSubmenuHeaderState,
): GroundingMenuSubmenuHeaderState => {
  'use no memo';

  const rootClassName = useRootClassName();
  state.root.className = mergeClasses(groundingMenuSubmenuHeaderClassNames.root, rootClassName, state.root.className);

  const backButtonStyles = useBackButtonStyles();
  if (state.backButton) {
    state.backButton.className = mergeClasses(
      groundingMenuSubmenuHeaderClassNames.backButton,
      backButtonStyles.root,
      state.backButton.className,
    );
  }

  const primaryTextClassName = usePrimaryTextClassName();
  if (state.primaryText) {
    state.primaryText.className = mergeClasses(
      groundingMenuSubmenuHeaderClassNames.primaryText,
      primaryTextClassName,
      state.primaryText.className,
    );
  }

  const secondaryTextClassName = useSecondaryTextClassName();
  if (state.secondaryText) {
    state.secondaryText.className = mergeClasses(
      groundingMenuSubmenuHeaderClassNames.secondaryText,
      secondaryTextClassName,
      state.secondaryText.className,
    );
  }

  return state;
};
